import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-social',
  templateUrl: './social.component.html'
})
export class SocialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
